import React, { useState } from 'react';
import cx from 'classnames';

import './styles';

const CopyLinkButton = ({ link, linkText, className }) => {
  const label = linkText || 'Copy Link';
  const [btnText, setBtnText] = useState(label);

  return (
    <div
      className={cx('copy-link-button', className)}
      onClick={() => {
        navigator.clipboard.writeText(link);
        setBtnText('Copied!');
        setTimeout(() => setBtnText(label), 2000);
      }}
    >
      {btnText}
    </div>
  );
};

export default CopyLinkButton;
